import ReactDOM from 'react-dom';

const Portal = ({ children, isNested = false }) => {

    const elementId = isNested ? "portal-root-nested" : "portal-root";
    
    const portalRoot = document.getElementById(elementId);
    return ReactDOM.createPortal(children, portalRoot);
}

export default Portal